export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyC03VE4FYwKB99WKoqhG4ZgXLbzNL36r7U',
    authDomain: 'smart-city-gamc.firebaseapp.com',
    projectId: 'smart-city-gamc',
    storageBucket: 'smart-city-gamc.appspot.com',
    messagingSenderId: '707595094285',
    appId: '1:707595094285:web:c7ad945222ca79fb3a8844',
    measurementId: 'G-1J2XKZGHZK'
  },
  baseLink: 'https://smart-city-gamc.web.app',
  IotToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzQ4MTI1NzU1LCJpYXQiOjE3MTY1ODk3NTUsImp0aSI6Ijc3ZjkxMWE0YmVlOTQ2YThiOWIwYmIwMmMwMjgzZWRjIiwidXNlcl9pZCI6MX0.ElxHE8j0CTrNqsOWOsN4IrKGiMnCkGL2Rmb2CjUXLmA',
  CiCoreApi: 'https://ci-core-api.cochabamba.bo',
  CiCoreApiWSS: 'wss://ci-core-api.cochabamba.bo',
  tenantId: '52f14cd4-c6f1-4fbd-8f87-4025e1d49242'
};
